import type { CategoryPage } from '@vgtv/api-client/lib/page';
import { Provider } from '@vgtv/api-client';
import { ComponentType, Layout } from '@vgtv/api-client/lib/component';
import type { Component } from '@vgtv/api-client/lib/component';

import { participantsBySeriesId } from './participants';

export const mixInParticipantsSlider = (pageConfig: CategoryPage) => {
  if (
    pageConfig.provider === Provider.VGTV &&
    pageConfig.category.id === 100441
  ) {
    pageConfig.components.splice(2, 0, {
      updatedBy: 'participant-cards',
      provider: Provider.VGTV,
      categoryId: pageConfig.category.id,
      options: {
        useVerticalPosters: false,
        usePageTaxonomy: false,
        layout: Layout.HORIZONTAL,
      },
      type: ComponentType.SLIDER,
      isShared: false,
      data: {
        type: 'cards',
        preset: participantsBySeriesId[pageConfig.category.id],
      },
      header: 'Deltakere',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      id: `participant-cards-${pageConfig.category.id}`,
    } as unknown as Component);
  } else if (
    pageConfig.provider === Provider.VGTV &&
    pageConfig.category.id === 100528
  ) {
    pageConfig.components.splice(2, 0, {
      updatedBy: 'participant-cards',
      provider: Provider.VGTV,
      categoryId: pageConfig.category.id,
      options: {
        useVerticalPosters: false,
        usePageTaxonomy: false,
        layout: Layout.HORIZONTAL,
      },
      type: ComponentType.SLIDER,
      isShared: false,
      data: {
        type: 'cards',
        preset: participantsBySeriesId[pageConfig.category.id],
      },
      header: 'Jobbsøkere',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      id: `participant-cards-${pageConfig.category.id}`,
    } as unknown as Component);
  }
};
